
import { Video } from '@/lib/api';
import VideoCardWrapper from '@/components/layout/VideoCardWrapper';

interface VideoGroupProps {
  date: string;
  videos: Video[];
  formatDateHeader: (date: string) => string;
}

const VideoGroup = ({ date, videos, formatDateHeader }: VideoGroupProps) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4 text-youtube-red dark:text-youtube-red border-b pb-2 border-gray-200 dark:border-gray-700">
        {formatDateHeader(date)}
      </h2>
      <div className="video-grid">
        {videos.map((video) => (
          <VideoCardWrapper key={video.id} {...video} />
        ))}
      </div>
    </div>
  );
};

export default VideoGroup;
